import { createApiHeadersInterceptor } from "@next-platform/client-common-core";
import axios from "axios";

/**
 * Dedicated axios instance for NextDay API calls. The shared interceptor injects
 * the standard application headers (auth, app id, build-time headers) on every
 * request. Third-party calls keep using the global `axios` import so they never
 * receive our auth headers.
 */
const apiClient = axios.create();

apiClient.interceptors.request.use(createApiHeadersInterceptor());

export default apiClient;
